import script from "./ModalPrivacyPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPrivacyPolicy.vue?vue&type=script&setup=true&lang=js"

import "./ModalPrivacyPolicy.vue?vue&type=style&index=0&id=4900189e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4900189e"]])

export default __exports__